






import { Component, Prop, Vue } from 'vue-property-decorator'
import PageHeader from '@/admin/components/PageHeader.vue'
import Form from '@/shared/components/form/Form.vue'
import FormBase from '@/shared/classes/form/form-base'
import Group from '@/shared/modules/group/group.model'
import Field from '@/shared/classes/form/field'
import __ from '@/shared/helpers/__'
import { GlobalActions } from '@/shared/store/global/global.actions'
import { SnackBarTypes } from '@/shared/helpers/snack-bar.helper'
import Company from '@/shared/modules/company/company.model'
import { CompanyGetters } from '@/shared/store/company/company.getters'
import { HttpMethod } from '@/shared/helpers/requests.helper'

@Component({
  components: { PageHeader, Form },
  methods: { __ }
})
export default class EditGroupDialog extends Vue {
  @Prop() meta: any
  form: FormBase|null = null

  created() {
    this.form = new FormBase()
      .setUuid(this.meta.group.uuid)
      .setEndpoint(`company/${ this.company.slug }/projects/${ this.meta.project.uuid }/groups`)
      .setMethod(HttpMethod.PUT)
      .setTranslatable(true)
      .setValidate(true, { onlyRegionLangRequired: true })
      .setModel(Group)
      .setFields([
        new Field()
          .setTranslatable(true)
          .setKey('name')
          .setTitle(__('company.components.views.projects.projects-show.edit-group-dialog.form.name'))
      ])
      .setSubmit({
        text: __('company.components.views.projects.projects-show.edit-group-dialog.form.submit')
      })
      .setOnSuccess(this.onSuccess)
  }

  private onSuccess(): void {
    this.$store.dispatch(GlobalActions.showSnackBar, {
      type: SnackBarTypes.success,
      message: __('company.components.views.projects.projects-show.edit-group-dialog.form.on-success')
    })
    this.$store.dispatch(GlobalActions.closeDialog)

    this.meta.onSuccess && this.meta.onSuccess()
  }

  get company(): Company {
    return this.$store.getters[CompanyGetters.getCompany]
  }
}
